import { gql, TypedDocumentNode } from '@common/hooks';
import {
  BulkUpdateWorkerScheduleCodesMutationCgResponse,
  BulkUpdateWorkerScheduleCodesMutationVariables,
  UpdateWorkerScheduleCodeMutationCgResponse,
  UpdateWorkerScheduleCodeMutationVariables,
} from '@common/graphql/schema';

export const UPDATE_WORKER_SCHEDULE_CODE_MUTATION: TypedDocumentNode<
  UpdateWorkerScheduleCodeMutationCgResponse,
  UpdateWorkerScheduleCodeMutationVariables
> = gql`
  mutation UpdateWorkerScheduleCode(
    $id: ID!
    $fteContributing: Boolean
    $fatigueContributing: Boolean
    $constraintType: String
    $displayName: String
    $description: String
    $incentive: Int
  ) {
    updateWorkerScheduleCode(
      id: $id
      fteContributing: $fteContributing
      fatigueContributing: $fatigueContributing
      constraintType: $constraintType
      displayName: $displayName
      description: $description
      incentive: $incentive
    ) {
      workerScheduleCode {
        id
        displayName
        description
        fteContributing
        fatigueContributing
        constraintType
        incentive
        lastEditedAt
      }
      errors {
        attribute
        errors
      }
    }
  }
`;

export const BULK_UPDATE_WORKER_SCHEDULE_CODES_MUTATION: TypedDocumentNode<
  BulkUpdateWorkerScheduleCodesMutationCgResponse,
  BulkUpdateWorkerScheduleCodesMutationVariables
> = gql`
  mutation BulkUpdateWorkerScheduleCodes(
    $ids: [ID!]!
    $fteContributing: Boolean
    $fatigueContributing: Boolean
    $constraintType: String
  ) {
    bulkUpdateWorkerScheduleCodes(
      ids: $ids
      fteContributing: $fteContributing
      fatigueContributing: $fatigueContributing
      constraintType: $constraintType
    ) {
      workerScheduleCodes {
        id
        fteContributing
        fatigueContributing
        constraintType
        lastEditedAt
        lastEditedBy
      }
      errors {
        attribute
        errors
      }
    }
  }
`;
